export default __webpack_public_path__ + "static/media/HeavensLakeMap.94e3a8a8.jpg";